import { post, get, put, deleteApi } from './axiosFun';

// 留言列表
export const boardList = (params) => { return post("/sys/leave-word/list", params) };
// 留言分页
export const boardPage = (params) => { return post("/sys/leave-word/page", params) };
// 留言详情
export const boardDetail = (leaveWordId) => { return get(`/sys/leave-word/detail/${leaveWordId}`) };
// 留言删除
export const boardRemove = (leaveWordId) => { return deleteApi(`/sys/leave-word/remove/${leaveWordId}`) };

// 留言编辑
export const boardEdit = () => { return put(`/sys/leave-word/edit`) };

// 留言新增
export const boardAdd = (params) => { return post("/sys/leave-word/add", params) };


// WEBPACK FOOTER //
// ./src/api/messageBoard.js